export enum ControlType {
  Text = 'text',
  Password = 'password',
  Date = 'date',
  Number = 'number',
  Tel = 'tel',
  Color = 'color',
}
